import React from "react";
import { withRouter, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faTable,
  faCaretUp,
  faCaretDown,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";
import Table from "react-bootstrap/Table";
class Developer1 extends React.Component {

  render() {
    return (
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-lg-8">
            <div className="widget widgetTable">
              <div className="row">
                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                  <p>Top Developers - Built Stock</p>
                </div>
                <div className="col-lg-3 text-end">
                  <Link to="/#" className="pe-3">
                    <FontAwesomeIcon icon={faChartBar} />
                  </Link>
                  <Link to="/#" className="colorBlack">
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </Link>
                </div>
                <div className="col-lg-12 mt-2">
                  <Table responsive hover>
                    <thead>
                      <tr className="">
                        <th>Developer</th>
                        <th>Built Stock(#)</th>
                        <th>Built Stock(msf)</th>
                        <th className="text-end">Occupancy(%)</th>
                        <th>Passing Rent</th>
                        <th>WALE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="">
                        <td>Embassy</td>
                        <td>92</td>
                        <td>117</td>
                        <td>71.3</td>
                        <td>82.6</td>
                        <td>56</td>
                      </tr>
                      <tr className="">
                        <td>Embassy</td>
                        <td>92</td>
                        <td>117</td>
                        <td>71.3</td>
                        <td>82.6</td>
                        <td>56</td>
                      </tr>
                      <tr className="">
                        <td>Embassy</td>
                        <td>92</td>
                        <td>117</td>
                        <td>71.3</td>
                        <td>82.6</td>
                        <td>56</td>
                      </tr>
                      <tr className="">
                        <td>Embassy</td>
                        <td>92</td>
                        <td>117</td>
                        <td>71.3</td>
                        <td>82.6</td>
                        <td>56</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="widget widgetGraph">
              <div className="row">
                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                  <p>Built Stock - Developer Share</p>
                </div>
                <div className="col-lg-3 text-end">
                  <Link to="/#">
                    <FontAwesomeIcon icon={faTable} />
                  </Link>
                  <Link to="/#" className="colorBlack">
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </Link>
                </div>
                <div className="col-lg-12">
                  {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-12">
            <div className="widget widgetTable">
              <div className="row">
                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                  <p>My Selected Developers</p>
                </div>
                <div className="col-lg-3 text-end">
                  <Link to="/#" className="pe-3">
                    <FontAwesomeIcon icon={faChartBar} />
                  </Link>
                  <Link to="/#" className="colorBlack">
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </Link>
                </div>
                <div className="col-lg-12 mt-2">
                  <Table responsive hover>
                    <thead>
                      <tr className="">
                        <th>Developer</th>
                        <th>Built Stock(#)</th>
                        <th>Built Stock(msf)</th>
                        <th className="text-end">Occupancy(%)</th>
                        <th>Passing Rent</th>
                        <th>WALE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="">
                        <td>Embassy</td>
                        <td>92</td>
                        <td>117</td>
                        <td>71.3</td>
                        <td>82.6</td>
                        <td>56</td>
                      </tr>
                      <tr className="">
                        <td>Embassy</td>
                        <td>92</td>
                        <td>117</td>
                        <td>71.3</td>
                        <td>82.6</td>
                        <td>56</td>
                      </tr>
                      <tr className="">
                        <td>Embassy</td>
                        <td>92</td>
                        <td>117</td>
                        <td>71.3</td>
                        <td>82.6</td>
                        <td>56</td>
                      </tr>
                      <tr className="">
                        <td>Embassy</td>
                        <td>92</td>
                        <td>117</td>
                        <td>71.3</td>
                        <td>82.6</td>
                        <td>56</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-8">
            <div className="widget widgetGraph">
              <div className="row">
                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                  <p>Top Developers - Built Stock</p>
                  <div className="row mt-2 mb-2">
                    <div className="col-lg-6">
                      <h4 className="colorGreen">
                        <FontAwesomeIcon icon={faCaretUp} size="lg" />
                        14%
                      </h4>
                      <p className="colorBlack pSmall">M-o-m vs Q1 CY’19</p>
                    </div>
                    <div className="col-lg-6">
                      <h4 className="colorRed">
                        <FontAwesomeIcon icon={faCaretDown} size="lg" />
                        -4%
                      </h4>
                      <p className="colorBlack pSmall">
                        Market Rent - INR 92 ps pm
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 text-end">
                  <Link to="/#">
                    <FontAwesomeIcon icon={faChartBar} />
                  </Link>
                  <Link to="/#" className="colorBlack">
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </Link>
                </div>
                <div className="col-lg-12">
                  {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="widget widgetGraph">
              <div className="row">
                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                  <p>Lease Volume - Developer Share</p>
                </div>
                <div className="col-lg-3 text-end">
                  <Link to="/#">
                    <FontAwesomeIcon icon={faTable} />
                  </Link>
                  <Link to="/#" className="colorBlack">
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </Link>
                </div>
                <div className="col-lg-12">
                  {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="widget widgetGraph">
              <div className="row">
                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                  <p>Rental Trends - Developers</p>
                  <h4 className="colorRed">
                    <FontAwesomeIcon icon={faCaretDown} size="lg" />
                    Embassy 4%
                  </h4>
                  <p className="colorBlack pSmall">Q-o-q vs Q3 Cy’20</p>
                </div>
                <div className="col-lg-3 text-end">
                  <Link to="/#">
                    <FontAwesomeIcon icon={faTable} />
                  </Link>
                  <Link to="/#" className="colorBlack">
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </Link>
                </div>
                <div className="col-lg-12">
                  {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="widget widgetGraph">
              <div className="row">
                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                  <p>Vacancy Trends - Developers</p>
                  <h4 className="colorRed">
                    <FontAwesomeIcon icon={faCaretDown} size="lg" />
                    Embassy 4%
                  </h4>
                  <p className="colorBlack pSmall">Q-o-q vs Q3 Cy’20</p>
                </div>
                <div className="col-lg-3 text-end">
                  <Link to="/#">
                    <FontAwesomeIcon icon={faTable} />
                  </Link>
                  <Link to="/#" className="colorBlack">
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </Link>
                </div>
                <div className="col-lg-12">
                  {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Developer1);
